import { MultiLangString } from './lingua_sistema';
import { Distretto, Comune, AreaVasta, AziendaSanitaria, Provincia } from './anagrafica_geo';
import { HmModelRest, HmModelRestNoName } from './abstract_model';

export class TipoServizioStruttura extends HmModelRest {
    static readonly rest_path = 'tipo_serv_strut';

    id: number;
    nome: string;
    ordinamento: number;

}

export class ServizioStruttura extends HmModelRestNoName {
    static readonly rest_path = 'servizi_struttura';

    getLabel(lang: string = 'it'): string {
        return this.tipo_serv_strut + ' ' + this.giorni;
    }

    id: number;
    ordinamento: number;
    giorni: string;
    tipo_serv_strut: number | TipoServizioStruttura;
    struttura: number | Struttura;
}


export class OrarioStruttura extends HmModelRestNoName {
    static readonly rest_path = 'orari_struttura';

    id: number;
    giorno: number;
    get labelGiorno(): string {
        switch (this.giorno) {
            case 1:
                return 'Lunedì';
            case 2:
                return 'Martedì';
            case 3:
                return 'Mercoledì';
            case 4:
                return 'Giovedì';
            case 5:
                return 'Venerdì';
            case 6:
                return 'Sabato';
            case 7:
                return 'Domenica';
            default:
                return '-';
        }
    }

    apertura_mattina: string;
    chiusura_mattina: string;
    apertura_pomeriggio: string;
    chiusura_pomeriggio: string;
    note: string;
    frequenza: string;

    get label_frequenza(): string {

        if (!this.frequenza)
            return null;

        const freq = this.frequenza.substring(0, 4);

        if (freq == '0000')
            return null;

        if (freq == '1111')
            return 'Tutte le settimane del mese';

        const sett: String[] = [];

        if (this.frequenza[0] == '1')
            sett.push('1a');

        if (this.frequenza[1] == '1')
            sett.push('2a');

        if (this.frequenza[2] == '1')
            sett.push('3a');

        if (this.frequenza[3] == '1')
            sett.push('4a');

        if (this.frequenza[4] == '1')
            sett.push('5a');

        return sett.join(', ') + ' sett. del mese';

    }
    get sintesi(): string {
        if (!this.apertura_mattina) {
            if (this.apertura_pomeriggio) {
                return 'Aperto solo il pomeriggio';
            } else {
                return 'Chiuso';
            }
        } else {
            if (this.chiusura_pomeriggio) {
                if (this.chiusura_mattina) {
                    return 'Aperto la mattina e il pomeriggio con pausa pranzo';
                } else {
                    return 'Aperto la mattina e il pomeriggio senza pausa pranzo';
                }
            } else {
                return 'Aperto solo la mattina';
            }
        }
    }

}

export class TipologiaStruttura extends HmModelRest {
    static readonly rest_path = 'tipologie_struttura';

    id: number;
    nome: MultiLangString;
    ordinamento: number;
}

export class Struttura extends HmModelRest {
    static readonly rest_path = 'strutture';

    id: number;
    nome: MultiLangString;
    descrizione: MultiLangString;
    indirizzo: string;
    indicazioni: MultiLangString;
    parent: number | Struttura;
    ordinamento: number;
    token: boolean;
    codice_cup: string;
    codice_cup_risorsa: string;
    telefono: string;
    email: string;
    cap: string;
    // responsabile: number;
    contatto_telefono: string;
    contatto_email: string;
    personale: string;
    latitudine: number;
    longitudine: number;
    rigenera_token_id: number;

    comune: number; // | Comune;
    provincia: number; // | Provincia;
    distretto: number; // | Distretto;
    percorso_gravidanza: boolean;
    tipologia_struttura: number | TipologiaStruttura;
    servizi_struttura: number[] | ServizioStruttura[];
    orari_struttura: number[] | OrarioStruttura[];

    token_accesso: string;
    email_token_access: string;
    codice_presidio_unita: string;

    area_vasta: number; // | AreaVasta;
    azienda_sanitaria: number ;
    referente_struttura: number;
    email_referente_struttura: string;
    comuni_abbinati: number[];
}

